import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jbqfywxgpa: FaireBrandEntity = {
  token: "b_jbqfywxgpa",
  type: "brand",
  name: "Solaray",
  avatarUrl:
    "https://cdn.faire.com/fastly/695aecab3f52f3d424a5b2415149a6c741520f914b65c5c92bd26fbbe45f8744.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/0e360825ad4e99955643b853f8ff73df70794486b7f8fe22c0115dcf3661a1b7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/695aecab3f52f3d424a5b2415149a6c741520f914b65c5c92bd26fbbe45f8744.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0e360825ad4e99955643b853f8ff73df70794486b7f8fe22c0115dcf3661a1b7.jpeg",
  location: "Salt Lake City, UT, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 9,
  isTopShop: true,
  isInsider: true,
  description:
    "Live Brighter\n\nOUR ANTHEM\nOur Mission.\n\nSince 1973, we’ve scoured the globe for the highest-quality ingredients, connecting you with the most efficacious supplements that help you Live Brighter and embrace the moments that matter most.\n\nBACKED BY SCIENCE\nRooted in Nature.\n\nWe create thoughtful, high-quality formulas using carefully selected ingredients sourced from the earth.\n\nTHE SOLARAY DIFFERENC\nLab Verified.\n\nOur state-of-the-art labs and advanced technology empower us to test and retest each of our 700+ products, ensuring some of the highest-quality supplements available.\n\nOur in-house scientist roster consists of both Masters and Ph.D. degree experts within the fields of biochemistry, biology, and related priority disciplines.\n\nWHO WE ARE\n\nWith over 700 vitamin, mineral, herbal, and other supplements available in health food stores across the globe and online, we’re there to support your wellness goals no matter where you are in your journey.\n\nBORN IN 1973\nMade in Utah.\n\nOur legacy was built upon the belief that nature was the very source of healthy nutrition and held the key to wellness. Our purpose is to inspire people to pursue healthier, better lifestyles one step at a time.\n\nOUR LEGACY.\nOur Impact.\n\nOur legacy is rooted in our natural surroundings, making it essential for us to live our values through tangible initiatives that reduce, repurpose, and recycle to decrease our carbon footprint.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:05.587Z",
    importedBy: "entity-db-cli",
  },
};
